export default {
  alarm_notification_rule: {
    name: '告警通知规则',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '规则名',
      trigger_station_scope: '监控对象范围',
      charge_station: '监控对象',
      alarm_notification_indicators: '通知指标',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    trigger_station_scopes: {
      public_stations: '对外充电站',
      specified_stations: '指定充电站'
    },
    alarm_notification_indicators: {
      alarm_category: '告警类型',
      duration: '持续时长'
    },
    labels: {
      stations: '充电站',
      alarm_notification_indicators: '{0}持续时长{1}分钟; '
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '规则名'
    },
    trigger_stations: {
      all_public_stations: '全部对外充电站'
    },
    tips: {
      alarm_notification_indicator: '满足以下任意一个指标都触发告警'
    },
    validates: {
      invalid_alarm_notification_indicators: '通知指标不能为空'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    // 标签标题
    // 标题
    titles: {
      base_info: '基本信息',
      time: '时间信息',
      notification_subscriptions: '订阅管理信息'
    }
  }
}
